<template>
  <div class="sarpa-popup user-popup">
    <div class="popup-header" style="background: linear-gradient(135deg, #fb8c00 0%, #f57c00 100%);">
      <div class="popup-header-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        </svg>
      </div>
      <div class="popup-header-text">
        <div class="popup-entity-name">{{ data.name || 'Unknown User' }}</div>
        <div class="popup-entity-sub">App User</div>
      </div>
    </div>

    <div class="popup-body">
      <div class="popup-row" v-if="data.phone">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
        <span>{{ data.phone }}</span>
      </div>
      <div class="popup-row" v-if="data.district">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
        <span>{{ data.district }}</span>
      </div>
      <div class="popup-row" v-if="data.create_date || data.createdAt">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/></svg>
        <span>{{ formatDate(data.create_date || data.createdAt) }}</span>
      </div>
    </div>

    <div class="popup-actions">
      <button class="popup-btn primary" @click="viewUser">
        View User
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserPopup',
  props: {
    data: { type: Object, required: true },
  },
  methods: {
    formatDate(d) {
      if (!d) return '-';
      try {
        const [y, m, day] = d.slice(0, 10).split('-');
        return `${day}-${m}-${y}`;
      } catch { return d; }
    },
    viewUser() {
      if (this.$router && this.data._id) {
        this.$router.push({ name: 'editUser', query: { id: this.data._id } });
      }
    },
  },
};
</script>


